import { useEffect, useRef } from "react";

import { useAuth } from "react-oidc-context";

import { LoadingOverlay } from "../../components/common/LoadingOverlay";
import { useAppDispatch } from "../../store/hooks";
import { logout } from "../../store/slices/authSlice";
import { clearServiceData } from "../../store/slices/serviceSlice";

const SignOutOidc = () => {
  const auth = useAuth();
  const dispatch = useAppDispatch();
  const redirectInitiated = useRef(false);

  useEffect(() => {
    const completeSignout = async () => {
      // Prevent multiple redirects
      if (redirectInitiated.current) {
        return;
      }
      redirectInitiated.current = true;

      try {
        // Clear local state
        dispatch(logout());
        dispatch(clearServiceData());
        localStorage.removeItem("original_route");

        // Remove user from OIDC storage
        await auth.removeUser();
      } catch (error) {
        console.error("Error during signout cleanup:", error);
      }

      // Use window.location to redirect - this avoids OIDC state issues
      // Redirect to root which will trigger a fresh sign-in flow
      window.location.href = "/";
    };

    completeSignout();
  }, [auth, dispatch]);

  return <LoadingOverlay />;
};

export default SignOutOidc;
